import { MyOrganizationHealthSystem } from './MyOrganizationHealthSystem'
import ViewEditHSContextProvider from '../HealthSystems/FullView/Providers/HSContextProvider'
import BankingSetupPopupProvider from '../BankingSetupCommunity/Providers/BankingSetupPopupProvider'

export const MyOrganizationHealthSystemContainer = () => (
  <BankingSetupPopupProvider>
    <ViewEditHSContextProvider outsideCommunityMode>
      <MyOrganizationHealthSystem />
    </ViewEditHSContextProvider>
  </BankingSetupPopupProvider>
)
